export default "__VITE_ASSET__eFOh8Gxm__"